<template>
    <div class="kanban-container">
        <div class="loading-overlay" v-if="showKanbanContainerOverlay">
            <div class="loading-text">Cargando datos, por favor espere...</div>
        </div>
        <div class="kanban-wrapper">
            <div class="kanban-column-wrapper">
                <div class="kanban-column-header">
                    <span>Pendientes</span>
                    <button :class="['btn', queueEditActive?'btn-danger':'btn-secondary', 'update-button']" :title="queueEditActive?'Actualizaciones automaticas bloqueadas. Para reanudar guarde los cambios':'Ultima actualizacion'">
                        <span>{{ lastUpdateTime }}</span>
                        <b-icon-lock class="m-0" v-if="queueEditActive" ></b-icon-lock>
                        <b-icon-clock-history class="m-0" v-else ></b-icon-clock-history>
                    </button>
                </div>
                <KanbanBoard
                    :orderStateId="OrderStates.PENDING"
                    :title="'Pendientes'"
                    :kanbanGroup="'pendingOrderReferences'"
    
                />
    <!--                :dragOptions="dragOptions"-->
            </div>
            <KanbanBoardList
                :title="'En Cola'"
                :orderStateId="OrderStates.QUEUED"
                :kanbanGroup="'pendingOrderReferences'"
            />
            <KanbanBoardList
                :title="'En Produccion'"
                :orderStateId="OrderStates.IN_PRODUCTION"
                :kanbanGroup="'lockedInProductionOrderReferences'"
            />
            <KanbanBoardList
                :title="'Finalizado'"
                :orderStateId="OrderStates.PRODUCED"
                :kanbanGroup="'lockedFinishedOrderReferences'"
            />
        </div>
    </div>
</template>

<script>

import Draggable from 'vuedraggable';
import KanbanBoard from "./KanbanBoard";
import KanbanBoardList from "./KanbanBoardList";
import { mapGetters, mapActions } from 'vuex';

import { OrderStates } from "../utils";

export default {
    name: "Kanban",
    components:{
        Draggable,
        KanbanBoard,
        KanbanBoardList
    },
    props:{},
    data(){
        return{
            OrderStates: OrderStates,
            orderReferencesLists:{}
        }
    },
    computed:{
        ...mapGetters('production_control',['activeModals','orderReferences', 'orderReferencesByStateId', 'orderReferencesByStateIdAndProductionLineId', 'lastUpdateTime','queueEditActive', 'showKanbanContainerOverlay']),
        ...mapGetters(['productionLines']),
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    },
    methods:{
        changeOrderReferenceList(id,productionLine, originalListState, targetListState){
            var order = this.orderReferencesLists[originalListState].find(o => o.id == id);
            this.orderReferencesLists[originalListState].splice(
                this.orderReferencesLists[originalListState].indexOf(order), 1
            )
            this.orderReferencesLists[targetListState].push(order)
        },
        // async input(newValue){
        //     console.log('INPUT', newValue)
        // },
        // add(e){
        //     console.log('ADD',e)
        // },
        // remove(e){
        //     console.log('REMOVE',e)
        // },

        testingButton(){
            this.changeOrderReferenceList(3,OrderStates.PENDING, OrderStates.IN_PRODUCTION )
        },
        checkModals() {}
    },
    mounted(){
        let self = this;

        Object.values(OrderStates).forEach((orderState, i) => {
            if(orderState == OrderStates.PENDING){
                return self.orderReferencesLists = {
                    ...self.orderReferencesLists,
                    [orderState]:[...self.orderReferencesByStateId(orderState)]
                }
            }
            self.productionLines.forEach((productionLine, j) => {
                self.orderReferencesLists[orderState] = {
                    ...self.orderReferencesLists[orderState],
                    [productionLine.id]:[...self.orderReferencesByStateIdAndProductionLineId(orderState, productionLine.id)]
                }
            })
        })

    }
}
</script>